import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {TypeList} from "./components/TypeList";

export const Type = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.tender_type')}`}
                         content={<TypeList/>}/>
}